<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import MZLocation from './models/MZLocation'
import configMixin from './mixins/configMixin'
// eslint-disable-next-line no-unused-vars

UIkit.use(Icons)
const defaultLayout = 'default'

export default {
  name: 'App',
  mixins: [configMixin],
  watch: {
    'permissionInfo.goodToGo': function (newVal, oldVal) {
      if (newVal) {
        UIkit.modal('#modal-full-location').hide()
      }
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  methods: {
    lookupLocation: function () {
      let location = MZLocation.query().where('beacon_region_id', '61b5a225-6de4-4cc7-9a29-66241e0b298e').get()
      console.log(location)
    }
  },
  mounted: function () {
    let userAgent = navigator.userAgent
    let isDevAndFakeCordova = (this.$store.getters.getDevModeIsDevMode && this.$store.getters.getDevModeFakeCordova)
    // Check Browser
    if (userAgent.includes('Cordova') || isDevAndFakeCordova) {
      this.$store.commit('setIsCordova', true)
      if (userAgent.includes('Macintosh') || userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod touch')) {
        this.$store.commit('setCordovaPlatform', 'iOS')
      } else {
        this.$store.commit('setCordovaPlatform', 'Android')
      }
    }

    if (isDevAndFakeCordova) {
      console.warn('IN DEVELOPMENT MODE!')
      this.$store.commit('setCordovaReady', true)
      // setTimeout(function () {
      //   store.commit('setCordovaResume', true)
      // }, 1500)
    }

    document.addEventListener('deviceready', (event) => {
      if (this.appConfig.application_name === 'Yokalize' && typeof universalLinks !== 'undefined') {
        // eslint-disable-next-line no-undef
        universalLinks.subscribe('redeemgift', (event) => {
          let path = event.path
          let pathSplit = path.split('/')
          // alert(JSON.stringify(pathSplit))
          // alert(pathSplit[3])
          // alert('store in store')
          this.$store.commit('storeGiftCardOndeck', pathSplit[3])
        })
      }
    })

    document.addEventListener('deviceready', () => {
      this.$store.commit('setCordovaReady', true)
      document.addEventListener('resume', () => {
        this.$store.commit('setCordovaResume', true)
      }, false)
    })
  }
}
</script>

<style lang='less'>
@import '../node_modules/uikit/src/less/uikit.less';
</style>



// WEBPACK FOOTER //
// src/App.vue